import React from 'react';
import RenderPDFPreview from '../global/RenderPDFPreview'
import {DEFAULT_PDF_ZOOM} from "../global/constants";
import "./Modal.css"
import axios from "axios";
import {BASE_URL} from "../global/Server/endpoints";

class FilePreviewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attemptFailed: false,
      pdfData: null,
    };

  }


  componentDidMount() {
    const { file } = this.props;
    if (file?.path && file?.type === 'application/pdf') {
      this.fetchPdfPreview(file.path);
    }
  }

  fetchPdfPreview = async (filePath) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
          `${BASE_URL}/folder/previewPDF`,
          { path: filePath },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
      );

      if (response?.data?.success && Array.isArray(response.data.pdfByte)) {
        const pdfData = new Uint8Array(response.data.pdfByte);
        this.setState({ pdfData });
      } else {
        console.warn("PDF preview failed:", response.data);
        this.setState({ attemptFailed: true });
      }
    } catch (error) {
      console.error('Error fetching PDF:', error);
      this.setState({ attemptFailed: true });
    }
  };

  render() {
    const { file, handlePdfLoadSuccess, handlePdfLoadError } = this.props;
    const { pdfData, attemptFailed } = this.state;

    if (!file) return null;

    return (
        <div style={{ margin: '20px 0' }}>
          {file.type?.startsWith('image') && (
              <div className="image-preview-container">
                <img
                    alt="preview"
                    src={file.url}
                    className="image-preview"
                    onError={() => this.setState({ attemptFailed: true })}
                />
              </div>
          )}

          {file.type === 'application/pdf' && pdfData && !attemptFailed && (
              <RenderPDFPreview
                  data={{ pdfData }}
                  creating={true}
                  handlePdfLoadSuccess={handlePdfLoadSuccess}
                  handlePdfLoadError={handlePdfLoadError}
                  scale={DEFAULT_PDF_ZOOM}
              />
          )}

          {attemptFailed && (
              <div className="error-message">
                Failed to preview file. Please try again or download it directly.
              </div>
          )}
        </div>
    );
  }
}

export default FilePreviewer;
